import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function heatmapColumnLabel(theme: Theme): ComponentStyle {
  return {
    componentName: 'heatmapColumnLabel',
    baseStyle: {
      color: theme.colors.muted,
      fontSize: theme.sizes['-1']
    }
  };
}
